import { createFeatureSelector } from '@ngrx/store';
import { CatalogState, CATALOG_FEATURE_KEY } from './catalog.reducer';

export const getCatalogState =
  createFeatureSelector<CatalogState>(CATALOG_FEATURE_KEY);
